import { useEffect, useState, useRef } from 'react';
import axios from '../../util/Axios';
import { Grid, Typography, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, IconButton, Button } from '@mui/material';
import Edit from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import EditHospital from './EditHospital';
import DeleteHospital from './DeleteHospital';
import { BooleanDisplay } from '../../components/BooleanDisplay';

function Hospitals() {
  const [hospitals, setHospitals] = useState([]);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openNewHospitalModal, setOpenNewHospitalModal] = useState(false);
  const [openDeleteHospitalModal, setOpenDeleteHospitalModal] = useState(false);

  const editedHospital = useRef(null);
  const deleteHospital = useRef(null);

  useEffect(() => {
    axios.get('/hospitals')
      .then(response => {
        setHospitals(response.data);
      });
  }, []);

  const handleOpenEditModal = (hospital) => {
    editedHospital.current = hospital;
    setOpenEditModal(true);
  };

  const handleCloseModal = () => {
    editedHospital.current = null;
    setOpenEditModal(false);
  };

  const handleOpenDeleteModal = (hospital) => {
    deleteHospital.current = hospital;
    setOpenDeleteHospitalModal(true);
  };

  const handleEditHospital = ({hospitalId, hospitalName, hospitalCountry, requiresMFA}) => {
    axios.put(`/hospitals/${hospitalId}/edit`, { name: hospitalName, country: hospitalCountry, requiresMFA })
      .then(() => {
        let editedHospital = hospitals.find(hospital => hospital.id === hospitalId);
        editedHospital.name = hospitalName;
        editedHospital.country = hospitalCountry;
        editedHospital.requiresMFA = requiresMFA;

        setHospitals([...hospitals]);
      });
  };

  const handleCreateHospital = ({hospitalName, hospitalCountry, requiresMFA}) => {
    axios.post('/hospitals', { name: hospitalName, country: hospitalCountry, requiresMFA })
      .then((response) => {
        hospitals.push(response.data);
        setHospitals([...hospitals].sort((hospital1, hospital2) => hospital1.name.localeCompare(hospital2.name)));
      });
  };

  const handleDeleteHospital = ({hospitalId, newHospitalName}) => {
    axios.delete('/hospitals/delete', { data: { currentHospitalId: hospitalId, newHospitalName: newHospitalName }})
      .then((response) => {
        let newList = hospitals.filter(hospital => hospital.id !== hospitalId);
        setHospitals(newList);
      });
  };

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Typography
            sx={{
              width: '100%',
              textAlign: 'center',
              marginTop: '16px',
              fontSize: '2em',
            }}
          >
            Hospitals
          </Typography>
        </Grid>
      </Grid>
      <Button variant="contained" onClick={() => setOpenNewHospitalModal(true)} sx={{ marginLeft: '16px', marginBottom: '16px' }}>
        Add Hospital
      </Button>
      <TableContainer>
        <Table
          sx={{
            minWidth: 650,
          }}
          aria-label="simple table"
          size="small"
        >
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Country</TableCell>
              <TableCell>MFA</TableCell>
              <TableCell>Edit</TableCell>
              <TableCell>Delete</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {hospitals.map((hospital) => (
              <TableRow key={hospital.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell>{hospital.name}</TableCell>
                <TableCell>{hospital.country || 'N/A'}</TableCell>
                <TableCell>
                  <BooleanDisplay value={hospital.requiresMFA}/>
                </TableCell>
                <TableCell>
                  <IconButton variant="contained" onClick={() => handleOpenEditModal(hospital)}>
                    <Edit />
                  </IconButton>
                </TableCell>
                <TableCell>
                  <IconButton variant="contained" onClick={() => handleOpenDeleteModal(hospital)}>
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      { openEditModal ?
        <EditHospital
          hospital={editedHospital.current}
          handleCloseModal={handleCloseModal}
          handleSaveChange={handleEditHospital}
        />
        :
        null
      }
      { openNewHospitalModal ?
        <EditHospital
          isNew={true}
          hospital={{}}
          handleCloseModal={() => setOpenNewHospitalModal(false)}
          handleSaveChange={handleCreateHospital}
        />
        :
        null
      }
      { openDeleteHospitalModal ?
        <DeleteHospital
          hospital={deleteHospital.current}
          hospitals={hospitals.filter(hospital => hospital.id !== deleteHospital.current.id)}
          handleCloseModal={() => setOpenDeleteHospitalModal(false)}
          handleSaveChange={handleDeleteHospital}
        />
        :
        null
      }
    </>
  )
}

export default Hospitals